import { createAction, props } from '@ngrx/store';

export const SetLoading = createAction(
  '[ Shared ] -  Set Loading page',
  props<{ isAppLoading: boolean }>()
);

export const SetCurrentElementId = createAction(
  '[ Shared ] -  Set CurrentElemnet Id',
  props<{ currentElementId?: number }>()
);

export const SetCurrentElementObject = createAction(
  '[ Shared ] -  Set CurrentElemnet Object',
  props<{ currentElementObject?: any }>()
);

export const toggle = createAction(
  '[ Shared ] - Toggle',
  props<{ toggle: boolean }>()
);

export const SetNavbarParams = createAction(
  '[Navbar] Set Navbar params',
  props<{ title: string | null, breadcrumbs: {label: string, url: string | null }[] | [], parentPath: string | null, icon: string | null }>()
);
export const ResetLoader = createAction(
  '[ Shared ] - reset loader action',
  props<{disable_loader: boolean}>()
);
